import React, { useContext } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Logo from "../../images/freshcart-logo.svg";
import { CartContext } from '../../Context/CartContext';
import "./Navbar.css"

export default function Navbar() {
    let {numOfCarts,userData,setUserData} = useContext(CartContext);
    const navigate = useNavigate();

    function logOut() {
        localStorage.removeItem("userToken");
        setUserData(null);
        navigate("/login");
        setTimeout(() => {
            window.location.reload();
        }, 0);
    }
    

    return (
        <>
        <nav className="navbar navbar-expand-lg fixed-top navbar-light bg-light">
            <div className="container">  
                <Link className="navbar-brand" to="/"><img src={Logo} alt="Logo" /></Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsibleNavId"
                        aria-controls="collapsibleNavId"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="collapsibleNavId">
                    {userData ? (
                        <ul className="navbar-nav me-auto mt-2 mt-lg-0 the-links" id='genNav'>
                            <li className="nav-item">
                            <NavLink 
                                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                                to="/">Home</NavLink>
                            </li>
                            <li className="nav-item">
                            <NavLink 
                                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                                to="/featuredProducts"
                            >
                                Products
                            </NavLink>
                            </li>
                            <li className="nav-item">
                            <NavLink 
                                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                                to="/categories"
                            >
                                Categories
                            </NavLink>
                            </li>
                            <li className="nav-item">
                            <NavLink 
                                className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} 
                                to="/brands"
                            >
                                Brands
                            </NavLink>
                            </li>
                        </ul>
                    ) : null}
                    <ul className="navbar-nav ms-auto mt-2 mt-lg-0">
                            <li className="nav-item d-flex align-items-center">
                            <i className="fab mx-2 fa-facebook"></i>
                            <i className="fab mx-2 fa-twitter"></i>
                            <i className="fab mx-2 fa-instagram"></i>
                            <i className="fab mx-2 fa-tiktok"></i>
                            <i className="fab mx-2 fa-linkedin"></i>
                            <i className="fab mx-2 fa-youtube"></i>
                            </li>
                    {userData ? (
                                <>
                                    <li className="nav-item" id='cart'><Link className="nav-link p-2 position-relative" to="/cart" aria-current="page">
                                        <i className='fas fa-shopping-cart fa-lg'></i>
                                        <span className='badge bg-main position-absolute top-0 text-white' >{numOfCarts}</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                    <button className="nav-link active btn btn-link p-0" aria-current="page" onClick={logOut}>Logout</button>
                                </li>
                                </>
                            ) : (
                                <>
                                    <li className="nav-item"><Link className="nav-link active" to="/login" aria-current="page">Login</Link></li>
                                    <li className="nav-item"><Link className="nav-link active" to="/register" aria-current="page">Register</Link></li>
                                </>
                            )}
                    </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}
